module.exports = __webpack_public_path__ + "img/ShotManagerPlugins.5e32b519.png";